import { useState, useEffect } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DatePickerCom(props) {
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (
      props.state &&
      props.state.date1 == undefined &&
      props.state.date2 == undefined
    ) {
      setValueStart();
      setValueEnd();
    }
  }, [props.state]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    props.setState({ ...props.state, date1: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    props.setState({ ...props.state, date2: newValueEnd });
  }, [valueEnd]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isSmall ? "column" : "row",
        alignItems: isSmall ? "flex-start" : "center",
        gap: 1,
      }}
    >
      <Typography variant="body2" sx={{ mr: 2 }}>
        تاریخ : از{" "}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <DatePicker
          // highlightToday={false}
          onOpenPickNewDate={false}
          weekDays={weekDays}
          calendar={persian}
          locale={persian_fa}
          format="YYYY-MM-DD"
          value={valueStart}
          onChange={setValueStart}
          render={
            <TextField
              sx={{ input: { textAlign: "center" } }}
              variant="outlined"
              size="small"
              fullWidth
              label="تاریخ شروع"
            />
          }
        />
        <Typography variant="body2" sx={{ mx: 1 }}>
          تا
        </Typography>
        <DatePicker
          // highlightToday={false}
          onOpenPickNewDate={false}
          weekDays={weekDays}
          calendar={persian}
          locale={persian_fa}
          format="YYYY-MM-DD"
          value={valueEnd}
          onChange={setValueEnd}
          render={
            <TextField
              sx={{ input: { textAlign: "center" } }}
              variant="outlined"
              label="تاریخ پایان"
              size="small"
              fullWidth
            />
          }
        />
      </Box>
    </Box>
  );
}
